import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import Invoice from './fundTransferInvoice'; // reuse the same Invoice component
import './invoicePage.css';

function FundTransferInvoicePage() {
    const { transactionId } = useParams();
    const history = useHistory();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => setLoading(false), 200);
    }, [transactionId]);

    return (
        <div className="invoice-page-layout compact">
            <div className="invoice-page-content compact">
                {loading ? (
                    <div className="compact-loading">
                        <div className="compact-spinner"><div className="spinner-circle"></div></div>
                        <p>Loading receipt...</p>
                    </div>
                ) : (
                    <div className="invoice-container-compact">
                        <Invoice
                            transactionId={transactionId}
                            invoiceType="fundtransfer"  // 👈 force fund transfer
                            isPageView={true}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default FundTransferInvoicePage;